import { formatMessage, UiMessages } from '../uiMessages';
import {
  FILE_SIZE_DISPLAY_DECIMAL_PLACES,
  MAX_MEDIA_FILES,
  MAX_MEDIA_FILE_SIZE_BYTES,
  MAX_MEDIA_FILE_SIZE_MB,
  MAX_TRANSCRIPT_FILE_SIZE_BYTES,
  MAX_TRANSCRIPT_FILE_SIZE_MB,
  MEDIA_EXTENSIONS,
  TRANSCRIPT_EXTENSIONS
} from '../uploadControlConfig';

export function getMediaCountLimitMessage() {
  return `Please remove some media files. The upload control allows up to ${MAX_MEDIA_FILES} media files.`;
}

export function getPageIntroMessage() {
  return formatMessage(UiMessages.pageIntro, {
    maxMediaFiles: MAX_MEDIA_FILES
  });
}

export function getSupportedTypesMessage() {
  return formatMessage(UiMessages.mediaFileInvalid, {
    maxFileSizeMb: MAX_MEDIA_FILE_SIZE_MB
  });
}

export function getSupportedTypesValidationMessage() {
  return getSupportedTypesMessage();
}

export function getMediaMaxFileSizeValidationMessage() {
  return formatMessage(UiMessages.mediaFileInvalid, {
    maxFileSizeMb: MAX_MEDIA_FILE_SIZE_MB
  });
}

export function getTranscriptMaxFileSizeValidationMessage() {
  return formatMessage(UiMessages.transcriptFileInvalid, {
    maxFileSizeMb: MAX_TRANSCRIPT_FILE_SIZE_MB
  });
}

export function formatSize(sizeInBytes) {
  if (!sizeInBytes) {
    return '0 MB';
  }

  const megaBytes = sizeInBytes / (1024 * 1024);
  const formatted = megaBytes.toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: FILE_SIZE_DISPLAY_DECIMAL_PLACES,
    useGrouping: false
  });
  return `${formatted} MB`;
}

export function getExtension(fileName) {
  const parts = String(fileName || '').split('.');
  return parts.length > 1 ? parts.pop().toLowerCase() : '';
}

export function isValidMediaFile(file) {
  return Boolean(file) && file.size > 0 && file.size <= MAX_MEDIA_FILE_SIZE_BYTES && MEDIA_EXTENSIONS.has(getExtension(file.name));
}

export function getMediaFileValidationMessage(file) {
  if (!file) {
    return getSupportedTypesValidationMessage();
  }

  if (file.size <= 0 || file.size > MAX_MEDIA_FILE_SIZE_BYTES) {
    return getMediaMaxFileSizeValidationMessage();
  }

  if (!MEDIA_EXTENSIONS.has(getExtension(file.name))) {
    return getSupportedTypesValidationMessage();
  }

  return '';
}

export function isValidTranscriptFile(file) {
  return Boolean(file) && file.size > 0 && file.size <= MAX_TRANSCRIPT_FILE_SIZE_BYTES && TRANSCRIPT_EXTENSIONS.has(getExtension(file.name));
}

export function getTranscriptFileValidationMessage(file) {
  if (!file) {
    return getSupportedTypesValidationMessage();
  }

  if (file.size <= 0 || file.size > MAX_TRANSCRIPT_FILE_SIZE_BYTES) {
    return getTranscriptMaxFileSizeValidationMessage();
  }

  if (!TRANSCRIPT_EXTENSIONS.has(getExtension(file.name))) {
    return getSupportedTypesValidationMessage();
  }

  return '';
}
